import {
  AllFulfillmentTypesType,
  OrderFulfillmentType,
} from "@sellar-io/api-v2/types";
import { ORDER_FULFILLMENT_TYPES } from "~/constants/sellarConstants.shared";

export const formatFulfillmentTypeLabel = (
  fulfillmentType: AllFulfillmentTypesType,
) => {
  const fulfillmentTypeValue =
    fulfillmentType === ("sellar-shipping" as OrderFulfillmentType)
      ? "courier"
      : fulfillmentType;

  return Object.values(ORDER_FULFILLMENT_TYPES).find(
    (option) => option.value === fulfillmentTypeValue,
  )?.name;
};
